module.exports = __webpack_public_path__ + "static/media/15-05.ee403483.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/videos/15-05.mp4
// module id = 126
// module chunks = 0